import { Divider } from 'antd';

import { PortalFilledStarIcon } from '@shared/assets-icon';
import { useGetHomePageTrendingArticlesQuery } from '@shared/services/sitecore';

import { WELL_BEING_AND_LIFESTYLE_LINKS } from '../../constants';
import { mapArticles } from '../../utils';
import ArticleSection from '../ArticleSection';
import ArticleSectionCollapse from '../ArticleSectionCollapse';
import Linkout from '../Linkout';

const WellBeingAndLifestyle = () => {
  const { data } = useGetHomePageTrendingArticlesQuery();
  const trendingArticles = mapArticles(data?.navigation?.wellBeingLifeStyle.trendingArticles);

  const articleSection = [
    {
      articles: trendingArticles,
      icon: <PortalFilledStarIcon className="text-white" />,
      title: 'Trending',
    },
  ];

  return (
    <div className="flex w-full flex-col lg:flex-row lg:gap-16">
      <div className="w-full lg:w-2/5">
        <Linkout className="grid-cols-1 lg:grid-cols-2" isCollapse={false} links={WELL_BEING_AND_LIFESTYLE_LINKS} />
      </div>
      <Divider className="m-0 hidden h-full border-dashed border-primary-green-3 lg:block" type="vertical" />
      <div className="hidden flex-1 grid-cols-1 gap-6 lg:grid">
        {articleSection.map(({ articles, icon, title }) => (
          <ArticleSection articles={articles} className="lg:grid-cols-2" icon={icon} key={title} title={title} />
        ))}
      </div>
      <ArticleSectionCollapse articleSection={articleSection} className="lg:hidden" />
    </div>
  );
};

export default WellBeingAndLifestyle;
